import useMutationApi from 'src/api/useMutationApi';

interface ApiResponse {
  success: boolean;
}

interface Body {
  inboundEmailId?: string;
}

const useReprocessInboundEmail = (onSuccess?: () => void) => {
  return useMutationApi<Body | void, ApiResponse>({
    endpoint: 'qa/reprocess-ingest-email',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useReprocessInboundEmail;
